import {Location} from '@angular/common';
import {Component, OnDestroy, OnInit, signal} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {filter, Subscription} from 'rxjs';
import {cachedRoutes, CacheableRouteName} from 'src/app/app-route-reuse-strategy';
import {LocalizationService} from '../../shared/services/localization.service';
import {doubleArrows} from './home.svgs';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
  /** When true, the global header is not rendered (set via route `data: { hideHeader: true }` on any matched segment under home). */
  hideHeader = false;

  private cachedScrollHeights: {[key: string]: number} = {};
  private subscriptions: Subscription[] = [];

  protected contentLeftCollapsed = signal<boolean>(false);
  public doubleArrowsIcon: SafeHtml = '';

  constructor(
    private localizationService: LocalizationService,
    private router: Router,
    private location: Location,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
  ) {
    this.doubleArrowsIcon = this.sanitizer.bypassSecurityTrustHtml(doubleArrows);
  }

  ngOnInit(): void {
    this.localizationService.fixLocale();
    this.refreshHeaderVisibility();

    this.subscriptions.push(
      this.router.events
        .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationEnd))
        .subscribe(event => {
          if (event instanceof NavigationStart) {
            const departurePath = this.location.path();
            if (cachedRoutes.includes(departurePath as CacheableRouteName)) {
              this.cachedScrollHeights[departurePath as CacheableRouteName] = window.scrollY;
            }
          }
          if (event instanceof NavigationEnd) {
            this.refreshHeaderVisibility();
            const arrivalPath = event.urlAfterRedirects;
            if (cachedRoutes.includes(arrivalPath as CacheableRouteName)) {
              const scrollHeight = this.cachedScrollHeights[arrivalPath as CacheableRouteName];
              setTimeout(() => {
                // Required. Else scrolling seems to happen too early.
                window.scrollTo({top: scrollHeight});
              }, 0);
            }
          }
        }),
    );
  }

  private refreshHeaderVisibility(): void {
    let child: ActivatedRoute | null = this.route.firstChild;

    this.hideHeader = false;

    while (child) {
      if (child.snapshot.data['hideHeader'] === true) {
        this.hideHeader = true;
        break;
      }
      child = child.firstChild;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  protected toggleSideContentCollapse() {
    this.contentLeftCollapsed.set(!this.contentLeftCollapsed());
  }
}
